var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 扫码成功，正在"+_vm._s(_vm.handlerType=='bind'?'绑定':'登录')+"... ")])}
var staticRenderFns = []

export { render, staticRenderFns }